export const HttpStatus={
  CONFLICT: 409,
  FORBIDDEN: 403,
  NO_CONTENT: 204,
  OK: 200,
  UNAUTHORIZED: 401,
  UNPROCESSABLE_ENTITY: 422
}